import { PAULO, RODRIGO } from "../assets/image";

export const WebsiteContent = [
  {
    NAV_MENU: [
      { id: "home", name: "INÍCIO" },
      { id: "about", name: "DM HEALTH" },
      { id: "soluctions", name: "SOLUÇÕES" },
      { id: "founders", name: "FUNDADORES" },
      { id: "contact", name: "CONTATO" },
    ],
    home: {
      title: "Saúde & Acolhimento",
      subtitle:
        "Acolhimento ao paciente, compromisso com os profissionais de saúde",
      content: (
        <span>
          A <strong>DM Health</strong> surgiu para aproximar profissionais de
          saúde e pacientes, tornando o cuidado mais simples, ágil e humano.
          Acreditamos que tecnologia e acolhimento devem andar juntos,
          garantindo uma experiência mais fluida e eficiente para todos. Nossa
          plataforma facilita a comunicação, organiza informações clínicas e
          acompanha a saúde no dia a dia, ajudando profissionais a tomarem
          decisões melhores e pacientes a receberem um atendimento mais próximo
          e acessível. Com foco em{" "}
          <strong>Pesquisa, Desenvolvimento & Inovação (PD&I)</strong>, levamos
          tecnologia para a prática assistencial de forma intuitiva, tornando o
          cuidado mais conectado, seguro e eficaz.{" "}
        </span>
      ),
      button: "SAIBA MAIS",
    },
    about: {
      titleOne: "Nosso Propósito",
      contentOne:
        "Facilitar o dia a dia de quem cuida e de quem é cuidado, usando tecnologia para aproximar pacientes e profissionais de saúde. Acreditamos que inovação e acolhimento devem andar juntos, garantindo um atendimento mais ágil, acessível e humano para todos.",
      titleTwo: "Onde Queremos Chegar",
      contentTwo:
        "Criar um futuro onde a tecnologia realmente melhore a saúde sem tirar o toque humano. Queremos ser referência em soluções digitais que simplificam processos, ajudam profissionais e tornam o cuidado mais conectado, eficiente e acessível para todos.",
      titleThree: "O Que Nos Move",
      data: [
        {
          title: "Cuidado de verdade",
          text: "A saúde precisa ser próxima, acolhedora e focada nas pessoas.",
        },
        {
          title: "Inovação que faz a diferença ",
          text: "Criamos soluções que melhoram o dia a dia de quem cuida e de quem é cuidado.",
        },
        {
          title: "Acesso para todos ",
          text: "Tecnologia que aproxima, sem barreiras e sem complicação.",
        },
        {
          title: "Segurança em primeiro lugar",
          text: "Protegemos os dados e respeitamos a privacidade de cada paciente.",
        },
        {
          title: "Futuro sustentável ",
          text: "Desenvolvemos tecnologia com impacto positivo para a saúde e para o mundo.",
        },
      ],
    },
    integration: {
      title: "DM HEALTH",
      subtitle: "Acompanhamento Inteligente de Saúde",
      content: (
        <span>
          <p>
            A <strong>DM Health</strong> possibilita um{" "}
            <strong>acompanhamento contínuo e integrado</strong>, trazendo
            informações do dia a dia do paciente para dentro do cuidado.
          </p>
          <br />
          <p>
            Isso significa que profissionais de saúde têm acesso a{" "}
            <strong>dados mais completos e atualizados</strong>, podendo agir de
            forma mais assertiva, prevenir complicações e personalizar ainda
            mais o atendimento.
          </p>
          <br />
          <p>
            Nosso compromisso é garantir que a tecnologia torne o cuidado mais
            intuitivo, seguro e eficiente, ajudando profissionais a{" "}
            <strong>
              tomar decisões com base em dados reais e no contexto de cada
              paciente
            </strong>
            .
          </p>
        </span>
      ),
    },
    details: {
      titleOne: "Integração e Consolidação de Informações",
      contentOne: (
        <span>
          <p>
            {" "}
            Reunimos todas as informações de saúde em um único lugar,{" "}
            <strong>de forma intuitiva e segura</strong>.
          </p>
          <br />
          <p>
            {" "}
            Isso melhora a{" "}
            <strong>
              comunicação entre equipes, acelera diagnósticos e torna a
              experiência mais fluida para o paciente
            </strong>
            .
          </p>
          <br />
          <p>
            {" "}
            Mais do que armazenar dados, a <strong>DM Health</strong> oferece um
            ecossistema digital onde as informações são conectadas de forma
            inteligente, promovendo um atendimento mais coordenado e eficiente.
          </p>
        </span>
      ),
      titleTwo: "Comunicação Direta e Humanizada",
      contentTwo: (
        <>
          <p>
            A <strong>DM Health</strong> facilita a{" "}
            <strong>
              troca de informações entre pacientes, profissionais de saúde,
              assistentes e gestores
            </strong>
            , garantindo que{" "}
            <strong>
              todos os envolvidos tenham acesso rápido e seguro às informações
              certas, no momento certo
            </strong>
            .
          </p>
          <br />
          <p>
            A tecnologia é um meio,{" "}
            <strong>
              mas o foco sempre será a proximidade e o acolhimento
            </strong>
            .
          </p>
          <br />
          <p>
            Nosso objetivo é tornar a comunicação em saúde{" "}
            <strong>mais clara, acessível e colaborativa</strong>, reduzindo
            ruídos, otimizando processos e garantindo que cada interação
            contribua para um cuidado mais eficiente e humanizado.
          </p>
        </>
      ),
    },
    commitment: {
      title: " Nosso Compromisso",
      subtitle:
        "A DM Health existe para garantir que a tecnologia esteja a serviço do cuidado e não o contrário.",
      content: (
        <span>
          <p>
            {" "}
            Nosso compromisso é{" "}
            <strong>
              oferecer suporte aos profissionais de saúde, garantir acolhimento
              ao paciente e tornar a experiência de assistência mais intuitiva e
              eficaz
            </strong>
            .
          </p>
          <br />
          <p>
            Trabalhamos <strong>nos ambientes reais da assistência</strong>,
            promovendo um cuidado mais conectado e personalizado. Também atuamos
            em <strong>parceria com centros de pesquisa e inovação</strong>,
            garantindo que nossas soluções sejam sempre atualizadas e alinhadas
            às melhores práticas do setor.
          </p>
          <br />
          <p>
            Nosso compromisso também está diretamente ligado aos{" "}
            <strong>
              Objetivos de Desenvolvimento Sustentável (ODS) da ONU
            </strong>
            :
          </p>
        </span>
      ),
      textFooter: (
        <p className="text-lg font-light text-white mt-10 mb-20">
          Nosso compromisso é{" "}
          <strong>
            tornar a tecnologia na saúde mais eficiente, sem perder o toque
            humano
          </strong>
          .
        </p>
      ),
      button: "SAIBA MAIS",
      data: [
        {
          title: "ODS 3 – Saúde e Bem-Estar",
          text: "Criamos soluções para uma assistência mais acessível, contínua e humanizada.",
        },
        {
          title: "ODS 5 – Igualdade de Gênero",
          text: "Defendemos um acesso equitativo à saúde para todos.",
        },
        {
          title: "ODS 8 – Trabalho Decente e Crescimento Econômico",
          text: "Investimos na formação de profissionais, impulsionando o crescimento do setor.",
        },
        {
          title: "ODS 9 – Indústria, Inovação e Infraestrutura",
          text: "Desenvolvemos tecnologias para digitalizar e modernizar a assistência à saúde.",
        },
        {
          title: "ODS 17 – Parcerias e Meios de Implementação",
          text: "Trabalhamos junto a universidades, centros de pesquisa e instituições de saúde para ampliar o impacto positivo.",
        },
      ],
    },
    founders: {
      title: "Fundadores",
      subtitle: "As mentes por trás da DM Health.",
      founders: [
        {
          photo: RODRIGO,
          name: "Rodrigo Dias",
          specialty: "Médico e Especialista em Tecnologia na Saúde",
          infos:
            "Médico e psiquiatra pela Faculdade de Medicina Botucatu – UNESP, Doutor pelo Departamento de Psiquiatria da Faculdade de Medicina da Universidade de São Paulo (USP).",
          linkedin: "https://www.linkedin.com/in/drrodrigodias/",
        },
        {
          photo: PAULO,
          name: "Paulo R. Machado",
          specialty: "Médico e Especialista em Gestão da Saúde",
          infos:
            "Médico, Anestesiologista e Doutor pela Faculdade de Medicina Botucatu – UNESP. MBA em Administração em Saúde pela FAAP- SP.",
          linkedin:
            "https://www.linkedin.com/in/paulo-roberto-d-aurea-machado-92ab9b1b1/",
        },
      ],
    },
    soluctions: {
      title: "Soluções",
      subtitle:
        "Profissionais de saúde e pacientes mais próximos nessa jornada.",
      description: (
        <p className="text-lg font-light text-white mb-8">
          A <strong>DM Health</strong> melhora a experiência de cuidado, unindo{" "}
          <strong>inteligência e comunicação</strong> para gerar{" "}
          <strong>resultados reais</strong>.
        </p>
      ),
      data: [
        {
          title: "Dynamic",
          content: (
            <p className="text-lg font-light text-white mb-8">
              Módulo de inteligência que estrutura e analisa dados clínicos,
              permitindo um{" "}
              <strong>
                acompanhamento contínuo, insights avançados e suporte à decisão
                baseado em evidências.
              </strong>
            </p>
          ),
        },
        {
          title: "Direct",
          content: (
            <p className="text-lg font-light text-white mb-8">
              Plataforma de comunicação que{" "}
              <strong>
                conecta pacientes, profissionais de saúde, assistentes e
                gestores
              </strong>
              , garantindo um{" "}
              <strong>acompanhamento integrado, seguro e humanizado</strong>,
              facilitando a troca de informações e aprimorando a jornada de
              cuidado.
            </p>
          ),
        },
      ],
      button: "FALE COM DM HEALTH",
    },
    contact: {
      title: "Contato",
      subtitle: (
        <h1 className="text-6xl font-black mb-8 ">
          Quer saber como a <br /> DM Health pode te <br /> ajudar?
        </h1>
      ),
      description:
        "Entre em contato e descreva qual é o seu interesse. Faça parte dessa jornada maravilhosa de promover bem-estar e saúde para o maior número de pessoas possível",
      inputs: ["Nome completo", "Email", "Telefone", "Mensagem"],
      button: "ENVIAR",
    },
    footer: {
      copy: (
        <p className="text-gray-600 mt-10 text-xs">
          Todos os direitos reservados <b>Dynamic Mind Health</b> 2025 &copy;
        </p>
      ),
      titleOne: "Navegação",
      items: [
        { id: "home", name: "Início" },
        { id: "about", name: "DM Health" },
        { id: "soluctions", name: "Soluções" },
        { id: "founders", name: "Fundadores" },
        { id: "contact", name: "Contato" },
      ],
      titleTwo: "Privacidade",
      itemOne: "Política de Privacidade",
      itemTwo: "Termos de Uso",
    },
  },
  {
    NAV_MENU: [
      { id: "home", name: "HOME" },
      { id: "about", name: "DM HEALTH" },
      { id: "soluctions", name: "SOLUTIONS" },
      { id: "founders", name: "FOUNDERS" },
      { id: "contact", name: "CONTACT" },
    ],
    home: {
      title: "Health & Care",
      subtitle: "Patient Care, Commitment to Healthcare Professionals",
      content: (
        <span>
          <strong>DM Health</strong> was created to bring healthcare
          professionals and patients closer together, making care simpler,
          faster, and more human. We believe that technology and care should go
          hand in hand, ensuring a smoother and more efficient experience for
          everyone. Our platform facilitates communication, organizes clinical
          information, and supports daily health monitoring, helping
          professionals make better decisions and enabling patients to receive
          more personalized and accessible care. With a strong focus on{" "}
          <strong>Research, Development & Innovation (RD&I)</strong>, we
          integrate technology into healthcare practice in an intuitive way,
          making care more connected, safe, and effective.
        </span>
      ),
      button: "LEARN MORE",
    },
    about: {
      titleOne: "Our Purpose",
      contentOne:
        "To simplify the daily lives of both caregivers and those receiving care, using technology to connect patients and healthcare professionals. We believe innovation and human-centered care should go together, ensuring faster, more accessible, and more humane healthcare for everyone.",
      titleTwo: "Where We Want to Go",
      contentTwo:
        "To create a future where technology truly enhances healthcare without losing the human touch. We strive to be a benchmark in digital solutions that simplify processes, support healthcare professionals, and make care more connected, efficient, and accessible to all.",
      titleThree: "What Drives Us",
      data: [
        {
          title: "Genuine Care",
          text: "Healthcare should be close, welcoming, and human-centered.",
        },
        {
          title: "Innovation That Makes a Difference",
          text: "We develop solutions that improve the daily lives of both caregivers and patients",
        },
        {
          title: "Access for All",
          text: "Technology that connects people—without barriers, without complications.",
        },
        {
          title: "Security First",
          text: "We protect data and respect every patient's privacy.",
        },
        {
          title: "A Sustainable Future ",
          text: "We develop technology with a positive impact on healthcare and the world.",
        },
      ],
    },
    integration: {
      title: "DM HEALTH",
      subtitle: "Smart Health Monitoring",
      content: (
        <span>
          <p>
            <strong>DM Health</strong> enables continuous and integrated health
            monitoring, bringing real-time patient data into the care process.
          </p>
          <br />
          <p>
            This means healthcare professionals have access to{" "}
            <strong>more complete and up-to-date information</strong>, allowing
            them to act more effectively, prevent complications, and personalize
            treatment even further.
          </p>
          <br />
          <p>
            Our commitment is to ensure that technology makes care more
            intuitive, safe, and efficient—helping professionals{" "}
            <strong>
              make data-driven decisions based on each patient's unique context
            </strong>
            .
          </p>
        </span>
      ),
    },
    details: {
      titleOne: "Integration and Information Consolidation",
      contentOne: (
        <span>
          <p>
            {" "}
            We centralize all health information in one{" "}
            <strong>secure and intuitive platform</strong>.
          </p>
          <br />
          <p>
            {" "}
            This improves{" "}
            <strong>
              team communication, accelerates diagnoses, and provides a smoother
              patient experience
            </strong>
            .
          </p>
          <br />
          <p>
            {" "}
            More than just storing data, <strong>DM Health</strong> creates a
            digital ecosystem where information is intelligently connected,
            promoting more coordinated and efficient care.
          </p>
        </span>
      ),
      titleTwo: "Direct and Humanized Communication",
      contentTwo: (
        <>
          <p>
            <strong>DM Health</strong> streamlines{" "}
            <strong>
              communication between patients, healthcare professionals,
              assistants, and managers
            </strong>
            , ensuring that{" "}
            <strong>
              all parties have quick and secure access to the right information
              at the right time
            </strong>
            .
          </p>
          <br />
          <p>
            Technology is a tool,{" "}
            <strong>
              but the focus is always on human connection and care
            </strong>
            .
          </p>
          <br />
          <p>
            Our goal is to make healthcare communication{" "}
            <strong>clearer, more accessible, and more collaborative</strong>,
            reducing misunderstandings, optimizing processes, and ensuring that
            every interaction contributes to more effective and human-centered
            care.
          </p>
        </>
      ),
    },
    commitment: {
      title: "Our Commitment",
      subtitle:
        "DM Health exists to ensure that technology serves care, not the other way around.",
      content: (
        <span>
          <p>
            {" "}
            Our commitment is{" "}
            <strong>
              to support healthcare professionals, ensure patient-centered care,
              and make the healthcare experience more intuitive and effective
            </strong>
            .
          </p>
          <br />
          <p>
            We operate <strong>in real-world healthcare environments</strong>,
            promoting more connected and personalized care. We also{" "}
            <strong>collaborate with research and innovation centers</strong>,
            to ensure that our solutions are always up to date and aligned with
            the industry's best practices.
          </p>
          <br />
          <p>
            Our commitment is also directly linked to the{" "}
            <strong>United Nations Sustainable Development Goals (SDGs)</strong>
            :
          </p>
        </span>
      ),
      textFooter: (
        <p className="text-lg font-light text-white mt-10 mb-20">
          Our mission is{" "}
          <strong>
            to make healthcare technology more efficient—without losing the
            human touch
          </strong>
          .
        </p>
      ),
      button: "LEARN MORE",
      data: [
        {
          title: "SDG 3 – Good Health and Well-being",
          text: "We create solutions for more accessible, continuous, and humanized healthcare.",
        },
        {
          title: "SDG 5 – Gender Equality",
          text: "We advocate for equitable access to healthcare for all.",
        },
        {
          title: "SDG 8 – Decent Work and Economic Growth",
          text: "We invest in professional training, driving growth in the healthcare sector.",
        },
        {
          title: "SDG 9 – Industry, Innovation, and Infrastructure",
          text: "We develop technologies to digitize and modernize healthcare.",
        },
        {
          title: "SDG 17 – Partnerships for the Goals",
          text: "We collaborate with universities, research centers, and healthcare institutions to maximize our positive impact.",
        },
      ],
    },
    founders: {
      title: "Founders",
      subtitle: "The minds behind DM Health.",
      founders: [
        {
          photo: RODRIGO,
          name: "Rodrigo Dias",
          specialty: "Physician & Health Technology Specialist",
          infos:
            "Medical doctor and psychiatrist, graduated from the Botucatu School of Medicine – UNESP. Ph.D. in Psychiatry from the University of São Paulo (USP).",
          linkedin: "https://www.linkedin.com/in/drrodrigodias/",
        },
        {
          photo: PAULO,
          name: "Paulo R. Machado",
          specialty: "Physician & Healthcare Management Specialist",
          infos:
            "Medical doctor, anesthesiologist, and Ph.D. from the Botucatu School of Medicine – UNESP. MBA in Healthcare Administration from FAAP-SP.",
          linkedin:
            "https://www.linkedin.com/in/paulo-roberto-d-aurea-machado-92ab9b1b1/",
        },
      ],
    },
    soluctions: {
      title: "Solutions",
      subtitle:
        "Bringing Healthcare Professionals and Patients Closer Together",
      description: (
        <p className="text-lg font-light text-white mb-8">
          <strong>DM Health</strong> enhances the care experience by combining{" "}
          <strong>intelligence and communication</strong> to deliver{" "}
          <strong>real results</strong>.
        </p>
      ),
      data: [
        {
          title: "Dynamic",
          content: (
            <p className="text-lg font-light text-white mb-8">
              An intelligence module that structures and analyzes clinical data,
              enabling{" "}
              <strong>
                continuous monitoring, advanced insights, and evidence-based
                decision support.
              </strong>
            </p>
          ),
        },
        {
          title: "Direct",
          content: (
            <p className="text-lg font-light text-white mb-8">
              A communication platform that{" "}
              <strong>
                connects patients, healthcare professionals, assistants, and
                managers
              </strong>
              , ensuring <strong>integrated, secure, and humanized care</strong>
              . It facilitates information exchange and enhances the patient
              care journey.
            </p>
          ),
        },
      ],
      button: "CONTACT DM HEALTH",
    },
    contact: {
      title: "Contact",
      subtitle: (
        <h1 className="text-6xl font-black mb-8 ">
          Want to know how <br /> DM Health pode te <br /> can help you?
        </h1>
      ),
      description:
        "Contact us and let us know your interest. Join us in this incredible journey to promote health and well-being for as many people as possible",
      inputs: ["Full Name", "Email", "Phone", "Message"],
      button: "SEND",
    },
    footer: {
      copy: (
        <p className="text-gray-600 mt-10 text-xs">
          All rights reserved <b>Dynamic Mind Health</b> 2025 &copy;
        </p>
      ),
      titleOne: "Navegação",
      items: [
        { id: "home", name: "Home" },
        { id: "about", name: "DM Health" },
        { id: "soluctions", name: "Solutions" },
        { id: "founders", name: "Founders" },
        { id: "contact", name: "Contact" },
      ],
      titleTwo: "Privacy",
      itemOne: "Privacy Policy",
      itemTwo: "Terms of Use",
    },
  },
];
